import { CompanyStatus } from "src/models/phoenix/globalTypes";

export enum CompanyActivityFilter {
  ALL = "ALL",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export const defaultCompanyActivity = CompanyActivityFilter.ACTIVE;

export interface CompanyWithActivity {
  id: string;
  status?: string | null;
}

export interface CompanyActivityResolution {
  groupIds: string[];
  hasMatches: boolean;
}

/**
 * Companies created before the status field was introduced have a null status.
 * They remain part of the active scope so the default filter does not hide them.
 */
export const isCompanyActive = (company: {
  status?: string | null;
}): boolean =>
  company.status == null || company.status === CompanyStatus.Active;

export const isCompanyInactive = (company: {
  status?: string | null;
}): boolean => company.status === CompanyStatus.Inactive;

export const resolveCompanyActivityIds = (
  activity: CompanyActivityFilter | null | undefined,
  selectedGroupIds: string[] | null | undefined,
  companies: CompanyWithActivity[],
): CompanyActivityResolution => {
  const selectedIds = Array.from(new Set(selectedGroupIds || []));

  if (!activity || activity === CompanyActivityFilter.ALL) {
    return { groupIds: selectedIds, hasMatches: true };
  }

  const matchingIds = new Set(
    companies
      .filter((company) =>
        activity === CompanyActivityFilter.ACTIVE
          ? isCompanyActive(company)
          : isCompanyInactive(company),
      )
      .map((company) => company.id),
  );
  const groupIds = selectedIds.length
    ? selectedIds.filter((id) => matchingIds.has(id))
    : Array.from(matchingIds);

  return { groupIds, hasMatches: groupIds.length > 0 };
};

export const companyActivityOptions = (allLabel: string) => [
  { label: allLabel, value: CompanyActivityFilter.ALL },
  { label: "Active companies only", value: CompanyActivityFilter.ACTIVE },
  { label: "Non active companies only", value: CompanyActivityFilter.INACTIVE },
];
